import { Box, Card, CardContent, Stack, Typography, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useTeamPageLayoutContext } from "..";
import { ContainerGrid, ViewToggleButtonGroup } from "../../../components";
import { TeamIssuesList, TeamTaskItemsList } from "./components";
import { useTeamImplementationSettings } from "./hooks";

interface IParams {
  slug: string;
}

const TeamImplementationPage = () => {
  const { team } = useTeamPageLayoutContext();
  const { slug: teamSlug } = useParams<keyof IParams>() as IParams;
  const isMdUp = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const { settings, updateSettings } = useTeamImplementationSettings(teamSlug);
  const [isTableView, setIsTableView] = useState(true);

  useEffect(() => {
    handleViewToggled(settings.tableView);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teamSlug]);

  useEffect(() => {
    if (isMdUp) {
      setIsTableView(settings.tableView);
    } else {
      setIsTableView(false);
    }
  }, [isMdUp, teamSlug, settings]);

  function handleViewToggled(value: boolean) {
    setIsTableView(value);
    updateSettings({
      tableView: value,
    });
  }

  return (
    <Stack spacing={1}>
      <Card>
        <CardContent>
          <Stack direction="row" spacing={1} sx={{ alignItems: "center", justifyContent: "space-between" }}>
            <Stack spacing={0.25}>
              <Typography variant="h5">Implementation</Typography>
              <Typography>Tasks and Loops</Typography>
            </Stack>
            {isMdUp && <ViewToggleButtonGroup isTableView={isTableView} onViewToggled={handleViewToggled} />}
          </Stack>
        </CardContent>
      </Card>
      <Box>
        <ContainerGrid container spacing={1}>
          <ContainerGrid size={{ md: isTableView ? 12 : 6, xs: 12 }}>
            <TeamTaskItemsList teamSlug={team.slug} isTableView={isTableView} />
          </ContainerGrid>
          <ContainerGrid size={{ md: isTableView ? 12 : 6, xs: 12 }}>
            <TeamIssuesList teamSlug={team.slug} isTableView={isTableView} />
          </ContainerGrid>
        </ContainerGrid>
      </Box>
    </Stack>
  );
};

export { TeamImplementationPage };
